import { useState, createContext } from 'react';
import { AlertableSignalFlowDTO } from '@atlassiansox/phobos-client-ts';

import { CRUDableType } from '@/meta';

export type EditDispatch = {
  dispatch: (arg: Partial<Editable>) => void;
  onOpen: () => void;
  onClose: () => void;
};

export interface Editable {
  publicId: string;
  type: CRUDableType;
  name?: string;
  capability?: FieldOption<string> & { publicId: string };
  isFormOpen: boolean;
  highlights?: { [key: string]: boolean };
}

function useEntityController() {
  const [state, setState] = useState<Editable>({
    publicId: '',
    type: 'capability',
    name: '',
    isFormOpen: false,
    highlights: {},
  });

  return {
    ...state,
    onOpen: () => setState(s => ({ ...s, isFormOpen: true })),
    onClose: () => setState(s => ({ ...s, isFormOpen: false, highlights: {} })),
    dispatch: (additionalState: Partial<Editable>) => setState(s => ({ ...s, ...additionalState })),
  };
}

export const EditContext = createContext<Editable & EditDispatch>({
  publicId: '',
  type: 'team',
  name: '',
  isFormOpen: false,
  highlights: {},
  onOpen: () => {},
  onClose: () => {},
  dispatch: () => {},
});

export type SignalFlowValidateResultType =
  | (AlertableSignalFlowDTO & { generalErrors?: string[] })
  | undefined;
export type SignalFlowValidateType = {
  error: SignalFlowValidateResultType;
  isValidating: boolean;
};
export const SignalFlowValidateContext = createContext<SignalFlowValidateType>({
  error: undefined,
  isValidating: false,
});

export default useEntityController;
